import { relations } from 'drizzle-orm'
import { date, index, pgTable } from 'drizzle-orm/pg-core'
import { getBaseFields, getBaseIndexes, getIdReference } from '../common/utils'
import { certificates } from './certificate'
import { employees } from './employee'

// A certificate held by an employee, with its validity window.
// The optional certificate photo is stored as an attachment
// (entityType = 'employeeCertificate', entityId = this row's id).
export const employeeCertificates = pgTable(
  'employee_certificates',
  {
    ...getBaseFields(),
    employeeId: getIdReference(() => employees.id),
    certificateId: getIdReference(() => certificates.id),
    validFrom: date(),
    validUntil: date(),
  },
  (table) => [
    ...getBaseIndexes('employee_certificates', table),
    index('employee_certificates_employee_id_idx').on(table.employeeId),
  ],
)

export const employeeCertificatesRelations = relations(
  employeeCertificates,
  ({ one }) => ({
    employee: one(employees, {
      fields: [employeeCertificates.employeeId],
      references: [employees.id],
    }),
    certificate: one(certificates, {
      fields: [employeeCertificates.certificateId],
      references: [certificates.id],
    }),
  }),
)
